var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"items":_vm.fibuFixErrors,"fields":_vm.fibufixErrorsFields,"total-rows":_vm.fibuFixErrors.length,"hide-search":true,"hide-per-page":true,"loading":_vm.loading},on:{"row-clicked":_vm.onRowClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }